/* Vue */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import vSelect from 'vue-select'

import router from '@/frontend/router';
import Frontend from '@/frontend/layouts/App.vue';
import axios from 'axios';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;

const pinia = createPinia()
const app = createApp(Frontend)
    .use(pinia)

app.component('v-select', vSelect)
app.use(router).mount('#frontend');


